<!-- <ng-content></ng-content> -->
<!-- <img *ngIf="url" [attr.src]="url" [attr.title]="title" [attr.alt]="title" [attr.aria-hidden]="true" /> -->
<i [ngClass]="icon"></i>
<i *ngIf="dropdown" class="dropdown icon icon-dropdown"></i>
<!-- <div
  class="notification"
  *ngIf="notifications > 0"
  [ngClass]="{ animate: animateNotification, init: animateInit }"
  (animationend)="onAnimationEnd()"
>
  {{ notifications }}
</div> -->
